<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							
							<v-flex xs12 sm4 md6>
								 <v-text-field label="Supplier Name" v-model="formSchema.name" :rules="[v => !!v || 'Field is required']" required></v-text-field>
							</v-flex>

							<v-flex xs12 sm4 md6>
								 <v-text-field label="FAX" v-model="formSchema.fax" :rules="[rules.fax]"></v-text-field>
							</v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Office Address" v-model="formSchema.office" :rules="[v => !!v || 'Field is required']" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Contact Person" v-model="formSchema.contact_person"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Phone" v-model="formSchema.phone" :rules="[rules.phoneNumber]" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md6>
                 <v-text-field label="E-mail" v-model="formSchema.email" :rules="[rules.email]" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Remarks" v-model="formSchema.remarks" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>	
								     <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>
						</v-layout>
					</v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success"  @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="resetForm" >Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema'],
    data: () => ({
      valid: true,
      isActiveVal: 0,
      rules: {
      email: (v) => {
        
        if (v && v.length > 0) {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) ||
          "E-mail must be valid";
        } else {
           return true
        }
      },
      phoneNumber: (v) => {
        //^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$
        if (v && v.length > 0) {
        return /^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{1,}\)?(\s?|\-?)\d{1,}\s?\d{1,})$/.test(v) ||
          "Phone no. must be valid";
        } else {
           return true
        }
      },
      fax: (v) => {
        if (v && v.length > 0) {
        return /^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{1,}\)?(\s?|\-?)\d{1,}\s?\d{1,})$/.test(v) ||
          "Fax no. must be valid";
        } else {
           return true
        }
      }
    },
         
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Supplier Information' : 'Add Supplier Information'
      },
      btnTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    created () { },
   
    methods: {
      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'proc_suppliers').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
						});
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'proc_suppliers').then(res => {
             let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
						});
          }
        }  
      },

      resetForm()
      {
        if (this.formSchema.id > 0) {
        // close(0);
         let actionData = {
                message: "Form Reset",
                data: this.formSchema,
                action: "edit",
                status: 1,
          };
        this.$emit("emitCloseModal", actionData);
        this.$refs.form.reset();
      } else {
        this.$refs.form.reset();
      }
      },

      close(data){
         if(data.status==1)
         {
           this.$refs.form.reset();
         }  
        this.$emit("emitCloseModal", data);
      },

    },

}
</script>



// WEBPACK FOOTER //
// src/components/procurement/supplier/supplierForm.vue